import React, {Component} from 'react';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {error: null, errorInfo: null}
    }

    static getDerivedStateFromError(error) {
        return {error};
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        this.props.onError && this.props.onError(this.props.children, errorInfo);
    }

    render() {
        const {children, fallback: Fallback} = this.props;
        const {error} = this.state;
        if (error !== null) {
            return <Fallback error={error}/>;
        }
        return children;
    }
}

ErrorBoundary.defaultProps = {
    fallback: () => null
}
